import { isDevelopment } from 'utils/environment';

/**
 * Get the uri for the infograph service
 *
 * Note: In development, the infograph service and editor2 are running on a different port,
 * so we need to remove the port from the uri
 * Example:
 *   Infograph service is running on http://localhost
 *   Editor2 is running on http://localhost:3000
 *   http://localhost:3000/design/create -> http://localhost/design/create
 *
 * @param path the path to the infograph service (e.g. /api/design/create)
 * @returns the full uri to the infograph service (e.g. https://infograph.venngage.com/api/design/create)
 */
export const getInfographUri = (path: string) => {
  const validatedPath = path.startsWith('/') ? path : `/${path}`;

  const currentProtocol = window.location.protocol;
  const currentHostname = window.location.hostname;

  // Home page pre-staging
  if (currentHostname.endsWith('.dev.venngage.beer')) {
    // This is hard coded for now. We do not have a proper pre-staging yet.
    return `${currentProtocol}//ai.infograph-dev.venngage.beer${validatedPath}`;
  }

  // infograph and the e2 pre staging
  if (currentHostname.endsWith('-dev.venngage.beer')) {
    // infogra and the e2 pre staging are under the same domain
    return path;
  }

  // E2 standalone, use the beer domain
  if (currentHostname.endsWith('venngage.vercel.app')) {
    return `${currentProtocol}//infograph.venngage.beer${validatedPath}`;
  }

  if (currentHostname.endsWith('localhost') || currentHostname.endsWith('.local')) {
    if (isDevelopment) {
      return `${currentProtocol}//${currentHostname.replace(/:\d+/, '')}${validatedPath}`;
    }

    return path;
  }

  // Others such as staging and production
  const hostname = currentHostname.startsWith('infograph') ? currentHostname : `infograph.${currentHostname}`;

  return `${currentProtocol}//${hostname}${validatedPath}`;
};
